// simple hook used by Navbar
import { useState, useEffect } from 'react';
export default function useWindowSize() {
  const [size, setSize] = useState({ width: typeof window !== 'undefined' ? window.innerWidth : undefined });
  useEffect(() => {
    const onResize = () => setSize({ width: window.innerWidth });
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return size;
}